export default __webpack_public_path__ + "static/media/icon_calendar.db4c154e.svg";